import { randomInt } from '@/utils/generators'
import Data from './data'

export default {
    list: ({ params }) => {
        const { entity } = params
        const data = Data.list.filter(item => item.entity === entity)
        return [200, { data }]
    },
    get: ({ params }) => [200, { data: Data.list[0] }],
    create: ({ data }) => [200, { data: { id: randomInt(1000), ...(JSON.parse(data) || {}) } }],
}
